import script from "./MapColorbarWrap.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapColorbarWrap.vue?vue&type=script&setup=true&lang=ts"

import "./MapColorbarWrap.vue?vue&type=style&index=0&id=26099026&lang=less"

const __exports__ = script;

export default __exports__